export default __webpack_public_path__ + "static/media/primariaLogo.c0ce00a5.jpg";